import { render, staticRenderFns } from "./plateTitle.vue?vue&type=template&id=78c8075a&scoped=true"
import script from "./plateTitle.vue?vue&type=script&lang=js"
export * from "./plateTitle.vue?vue&type=script&lang=js"
import style0 from "./plateTitle.vue?vue&type=style&index=0&id=78c8075a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8075a",
  null
  
)

export default component.exports